export default function InitSearch() {
  document.querySelectorAll('.search__input').forEach(function (el) {
    el.addEventListener('keydown', function (e) {
      /**
       * Right arrow key press autocompletes the search input
       */
      if (e.key === 'ArrowRight') {
        autoCompleteSearchCe()
      }
    })
  })

  /**
   * Inserts the type-ahead hint and clears the hint container
   */
  const autoCompleteSearchCe = () => {
    const searchContainer = document.querySelector('.block--solr_pi_search')
    const searchHintContainer = searchContainer.querySelector('.search__hint')
    const searchInput = searchContainer.querySelector('.search__input')

    const inputValue = searchInput.value
    const hintPhrase = searchHintContainer.textContent

    if (!!hintPhrase) {
      searchInput.value = inputValue + hintPhrase.substring(inputValue.length)
      searchHintContainer.innerHTML = ''
    }
  }
}
